// src/store/slices/discountsSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchDiscountsByHouseThunk = createAsyncThunk(
  "discounts/fetchByHouse",
  async (home_id, { rejectWithValue }) => {
    try {
      const res = await api.get(`/api/discounts/house/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const createDiscountThunk = createAsyncThunk(
  "discounts/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post(`/api/discounts`, payload);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return res.data; // { success, message, d_id }
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

export const deleteDiscountThunk = createAsyncThunk(
  "discounts/delete",
  async ({ d_id, home_id }, { rejectWithValue }) => {
    try {
      const res = await api.delete(`/api/discounts/${d_id}/${home_id}`);
      if (!res.data?.success) return rejectWithValue(res.data?.message || "Failed");
      return { d_id };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const discountsSlice = createSlice({
  name: "discounts",
  initialState: {
    list: [],
    loading: false,
    saving: false,
    deleting: null,
    error: null,
  },
  reducers: {
    clearDiscountsError: (s) => {
      s.error = null;
    },
  },
  extraReducers: (b) => {
    b.addCase(fetchDiscountsByHouseThunk.pending, (s) => {
      s.loading = true;
      s.error = null;
    });
    b.addCase(fetchDiscountsByHouseThunk.fulfilled, (s, a) => {
      s.loading = false;
      s.list = a.payload || [];
    });
    b.addCase(fetchDiscountsByHouseThunk.rejected, (s, a) => {
      s.loading = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(createDiscountThunk.pending, (s) => {
      s.saving = true;
      s.error = null;
    });
    b.addCase(createDiscountThunk.fulfilled, (s) => {
      s.saving = false;
    });
    b.addCase(createDiscountThunk.rejected, (s, a) => {
      s.saving = false;
      s.error = a.payload || "Failed";
    });

    b.addCase(deleteDiscountThunk.pending, (s, a) => {
      s.deleting = a.meta.arg?.d_id || null;
      s.error = null;
    });
    b.addCase(deleteDiscountThunk.fulfilled, (s, a) => {
      s.deleting = null;
      s.list = s.list.filter((x) => String(x.d_id) !== String(a.payload.d_id));
    });
    b.addCase(deleteDiscountThunk.rejected, (s, a) => {
      s.deleting = null;
      s.error = a.payload || "Failed";
    });
  },
});

export const { clearDiscountsError } = discountsSlice.actions;
export default discountsSlice.reducer;
